import { Card, Steps } from "antd";

// Card display for "Why Choose Us?"
const WhyChooseUs = () => (
  <Card
    title={
      <span style={{ fontSize: "28px", fontWeight: "bold" }}>
        Why Choose Us?
      </span>
    }
    bordered={false}
    style={{ width: "100%", maxWidth: 1200, margin: "0px auto" }}
  >
    <div style={{ maxWidth: 800, margin: "0 auto" }}>
      <Steps direction="vertical" current={4}>
        <Steps.Step
          title="New Business Model"
          description='To combat widespread scams in the market, we support a "make first, pay later, then ship" approach for your peace of mind.'
        />
        <Steps.Step
          title="Order Without Worry"
          description="After placing your order, you can choose not to pay immediately. Simply email our customer service and let us know you want us to make your ID first."
        />
        <Steps.Step
          title="See Before You Pay"
          description="We will produce your fake ID and send you photos of the finished product. Only pay when you are satisfied."
        />
        <Steps.Step
          title="Fast Shipping After Payment"
          description="Once you confirm and pay, we will ship your order right away. You will receive your tracking number within 48 hours."
        />
        <Steps.Step
          title="Honest & Trusted"
          description="This model effectively prevents scams and has earned the trust and praise of many customers, so you can order with confidence."
        />
      </Steps>
    </div>
  </Card>
);

export default WhyChooseUs;
